import { Facet, IFaceted } from '../models/Facet';

/**
 * @public
 */
export const getItemsOperation = new Facet<{
  demands: IFaceted<boolean>;
}>('getItems');
